<template>
  <v-card class="import-dataset">
    <v-card-title class="justify-center"> Edit Dataset </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="3" class="input-label">Dataset </v-col>
          <v-col cols="9">
            <v-text-field outlined dense v-model="title"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-6">
          <v-col cols="3" class="input-label">Types </v-col>
          <v-col cols="9" v-if="canEditConfig">
            <v-checkbox
              v-for="(t, i) in types"
              :key="i"
              hide-details
              dense
              v-model="typeIds"
              :label="t.name"
              :value="t.id"
            ></v-checkbox>
          </v-col>
          <v-col cols="9" v-else>
            <v-checkbox
              v-for="(t, i) in types"
              :key="i"
              hide-details
              dense
              v-model="typeIds"
              :label="t.name"
              :value="t.id"
              disabled
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3" class="input-label">Value Type </v-col>
          <v-col cols="9">
            <v-select
              outlined
              hide-details
              dense
              :items="valueTypeOptions"
              v-model="valueType"
            ></v-select>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-4">
          <v-col cols="3" class="input-label">Alias </v-col>
          <v-col cols="9">
            <v-text-field outlined dense v-model="alias"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && confirm()"
        depressed
        large
      >
        {{ $t("save") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { onMounted, ref, computed } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import { RBU_DATASET_VALUE_TYPE, USER_TYPE } from "@/constants";
import { PERMISSIONS } from "@/constants";
import _ from "lodash";

export default {
  name: "EditDatasetDialog",
  props: {
    dataset: Object,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const canEditConfig = computed(() => {
      if (!root.$store.getters.account) return false;
      return (
        [USER_TYPE.SUPER_ADMIN].includes(root.$store.getters.account.type) ||
        _.some([PERMISSIONS.MANAGE_RBU_DATASET], (p) =>
          root.$store.getters.hasPermission(p)
        )
      );
    });

    const title = ref(props.dataset.title);
    const alias = ref(props.dataset.alias);
    const typeIds = ref(props.dataset.types.map((t) => t.id));
    const types = ref([]);
    const getTypes = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset_type/",
        params: {
          page_size: -1,
        },
      });

      if (response.body.success) {
        types.value = response.body.types;
      }
    };

    const valueType = ref(props.dataset.value_type);
    const valueTypeOptions = ref([
      { text: "Price", value: RBU_DATASET_VALUE_TYPE.PRICE },
      { text: "Index", value: RBU_DATASET_VALUE_TYPE.INDEX },
    ]);
    const confirm = async function () {
      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/edit/",
        params: {
          dataset_id: props.dataset.id,
          value_type: valueType.value,
          title: title.value,
          type_ids: typeIds.value,
          alias: alias.value,
        },
      });

      if (response.body.success) {
        emit("submit", true);
      }
    };

    onMounted(() => {
      getTypes();
    });

    return {
      requiredRules,

      title,
      typeIds,
      types,
      alias,

      valueType,
      valueTypeOptions,

      confirm,
      canEditConfig,
    };
  },
};
</script>

<style lang="less">
.import-dataset {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }
}
</style>
